import { S_PART } from '@lba-dev/package.local-globals/services';

import store from '../store';

export const getTeam = (data, users, listen = 'artisans') => {
  let dataAreas;
  if (listen === 'artisans') {
    dataAreas = data.billingAddress.zipcode;
  } else if (listen === 'candidats') {
    dataAreas = data.address?.zipcode;
  } else {
    dataAreas = data.client?.address.zipcode;
  }
  const chief =
    (dataAreas &&
      users.find((u) =>
        u.areas && u.areas.includes(dataAreas.slice(0, 2)))) || {};
  return {
    login: chief.login || 'Non defini',
    equipe: chief.equipe || {},
  };
};


export const getUserTeam = (users = [], userId) =>
  users.find(
    (e) =>
      (e._id === userId && e.areas?.length) ||
      (e._id === userId && e.equipe?.ids?.length) ||
      e.equipe?.ids?.includes(userId)
  );
export const getChiefAreasByLogin = (login = '') => {
  if (!login) {
    return [];
  }

  const state = store.getState ? store.getState() : {};
  let users = state.users || [];

  if (users && users.toJS) {
    users = users.toJS();
  }

  const loginSearch = login.toLowerCase();
  const chiefs = users.filter((u) =>
    (u.login || '').toLowerCase().includes(loginSearch)
  );

  return Array.from(
    new Set(
      chiefs.reduce(
        (acc, u) => acc.concat(u.areas || []),
        []
      )
    )
  );
};

export const getAllChefDeZone = (users) =>
  users.filter((user) => user.service === S_PART && user.act && user.equipe);

